module.exports = __webpack_public_path__ + "static/media/d6kz.1c29966f.pdf";